<template>
    <main>
        <section
            class="max-w-md mx-auto py-24 px-4 divide-y-2 divide-blue-gray-200 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:py-32 lg:px-8"
            aria-labelledby="faq-heading"
        >
            <div class="md:flex justify-between">
                <SmartBreadcrumbs
                    type="InertiaLink"
                    :pages="[
                        {
                            name: $tc('messages.activities', 2),
                            href: meta.links.index,
                        },
                        {
                            name: activity.title,
                            href: null,
                        },
                    ]"
                />
                <AppButton element="a" :href="meta.links.rubric_print" target="_blank">
                    <IconPrinter class="-ml-0.5 mr-2 w-4 h-4" />
                    {{ $t('messages.print') }}
                </AppButton>
            </div>

            <div v-if="meta.links.show" class="flex justify-end">
                <InertiaSquareLinkButton action="show" :href="meta.links.show" />
            </div>

            <AppWell class="mt-1">
                <RubricGrade v-model="form.rubric" :ranges="activity.ranges" />
            </AppWell>
        </section>
    </main>
</template>

<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import AppWell from '@/Shared/AppWell.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import RubricGrade from '@/Pages/Teacher/Activities/Rubrics/RubricGrade.vue';
import AppButton from '@/components/AppButton.vue';
import { IconPrinter } from '@tabler/icons-vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';

export default {
    name: 'Show',
    props: ['activity', 'meta'],
    components: {
        InertiaSquareLinkButton,
        AppButton,
        AppWell,
        SmartBreadcrumbs,
        RubricGrade,
        IconPrinter,
    },
    layout: LandingLayout,
    data() {
        return {
            form: this.$inertia.form({
                rubric: JSON.parse(JSON.stringify(this.activity.rubric)),
            }),
        };
    },
};
</script>
